const getRandomPosition = (containerWidth, containerHeight, objectWidth, objectHeight) => {
    const position = {
        x: 0,
        y: 0
    };
    // Exclude space equal to object width on each edge
    const validXRange = containerWidth - objectWidth;
    const validYRange = containerHeight - objectHeight;
    position.x = (objectWidth / 2) + Math.floor(validXRange * Math.random());
    position.y = (objectHeight / 2) + Math.floor(validYRange * Math.random());
    return position;
}

const getRandomSpeed = (min, max) => {
    const speed = {
        x: 0,
        y: 0
    }
    speed.x = min + ((max - min) * Math.random());
    speed.y = min + ((max - min) * Math.random());
    return speed;
}

module.exports = { getRandomPosition, getRandomSpeed };